import React, { MouseEventHandler } from "react";
import { Button } from "antd";
import styles from "./Buttons.module.scss";

type ButtonType = "text" | "link" | "ghost" | "default" | "primary" | "dashed";

type CustomButtonProps = {
  handlerFunction: MouseEventHandler<HTMLElement>;
  text?: string;
  type: ButtonType;
  icon?: string;
  className?: string;
  id?: string;
};

const CustomButton: React.FC<CustomButtonProps> = ({
  handlerFunction,
  text,
  type,
  icon,
  className,
  id,
}) => {
  let buttonClass = className ? styles[className] : "";
  let buttonId = id ? styles[id] : "";

  return (
    <Button
      type={type}
      className={buttonClass}
      id={buttonId}
      onClick={handlerFunction}
    >
      {icon && <img src={icon} alt="button" />}
      {text}
    </Button>
  );
};

export default CustomButton;
